import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }

import type { NotificationVariant } from '@/services/notification.app'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppNotificationIcon',
  props: {
    variant: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(["app-notification-icon", `app-notification-icon--${__props.variant}`]),
    viewBox: "0 0 28 28"
  }, [
    (__props.variant === 'info' || __props.variant === 'unique')
      ? (_openBlock(), _createElementBlock("g", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("circle", {
            class: "app-notification-icon__bg",
            cx: "14",
            cy: "14",
            r: "12.8",
            fill: "currentColor"
          }, null, -1),
          _createElementVNode("path", {
            d: "M15.4 20v.3a2 2 0 0 1-1.6.7q-1 0-1.6-.5-.5-.6-.5-1.4l.3-2.4.7-3.6q0-.5-.4-.5H12a.2.2 0 0 1 0-.4h.7l2.5-.1q.2 0 .3.2l-1.4 7.5q0 .7.6.5l.2-.2q.2-.2.4 0M13.5 9.8q-.4-.5-.4-1.1 0-.8.4-1.2.5-.5 1.2-.5t1.1.5.5 1.2-.5 1.1-1.1.5-1.2-.5",
            fill: "currentColor"
          }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    (__props.variant === 'success')
      ? (_openBlock(), _createElementBlock("g", _hoisted_2, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("circle", {
            class: "app-notification-icon__bg",
            cx: "14",
            cy: "14",
            r: "12.8",
            fill: "currentColor"
          }, null, -1),
          _createElementVNode("path", {
            d: "m21 9.9-7.7 8.4-5.1-5.1",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    (__props.variant === 'warning')
      ? (_openBlock(), _createElementBlock("g", _hoisted_3, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("path", {
            class: "app-notification-icon__bg",
            d: "m16.4 4.8 8.9 15.7c1 1.8-.3 4-2.4 4H5.1a2.7 2.7 0 0 1-2.4-4l9-15.7c1-1.8 3.6-1.8 4.7 0",
            fill: "currentColor"
          }, null, -1),
          _createElementVNode("path", {
            d: "M14 15.3v-4.4",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.3",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, -1),
          _createElementVNode("path", {
            d: "M14 20.4q-1.2-.1-1.3-1.3a1.3 1.3 0 1 1 1.3 1.3",
            fill: "currentColor"
          }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    (__props.variant === 'error')
      ? (_openBlock(), _createElementBlock("g", _hoisted_4, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("circle", {
            class: "app-notification-icon__bg",
            cx: "14",
            cy: "14",
            r: "12.8",
            fill: "currentColor"
          }, null, -1),
          _createElementVNode("path", {
            d: "M17.7 18.8q.6.4 1.1 0 .4-.6 0-1l-.5.5zm-7.4-9.6a1 1 0 0 0-1 0q-.5.6 0 1l.5-.5zm-.5.5-.5.6 8.4 8.5.6-.5.5-.6-8.5-8.5z",
            fill: "currentColor"
          }, null, -1),
          _createElementVNode("path", {
            d: "M9.2 17.7q-.5.6 0 1.1.6.4 1 0l-.5-.5zm9.5-7.4q.4-.6 0-1.1a1 1 0 0 0-1 0l.5.5zm-.5-.6-.5-.5-8.5 8.5.5.6.6.5 8.4-8.5z",
            fill: "currentColor"
          }, null, -1)
        ]))]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})